import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppFilter } from '@app/shared/models';
import { SuiModal, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { Subject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  OrganizationService,
  FinanceService,
  ChatService,
} from '../../../services';

@Component({
  selector: 'app-conversation-screen',
  templateUrl: './conversation-screen.component.html',
  styleUrls: ['./conversation-screen.component.scss'],
})
export class ConversationScreenComponent implements OnInit {
  @Input() conversation;

  data;
  sessionId;

  isAdmin: boolean;
  @ViewChild('chatBoxElement') chatBoxElementRef!: ElementRef;
  successMessage;
  messageIndex;
  collapse = false;
  replyBlock;
  createPending: boolean;
  createError: string;
  success: string;
  error: any;
  organization: any;
  user: any;
  organizationId: string;
  messages;
  pending: boolean;
  total;
  page;
  records;

  maxSize = 5;
  requireDocs = [];
  documents: any[] = [];
  documentsType: any[];
  attachment = false;
  attachmentSuccess = false;
  removeAttachemt: boolean;
  fileError: any;
  selectedFile: any;

  replyForm: FormGroup;
  fileObj: any;
  fileName: string;

  messageParams: AppFilter;
  searchMessagesFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'level',
        op: 'eq',
        data: 0,
      },
    ],
  };
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'sessionId',
        op: 'eq',
        data: '',
      },
    ],
  };

  baseUrl = environment.API_SERVER;

  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'ownership_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'foreign_company_providers',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'contractor_relevant_docs',
      },
    ],
  };
  uploadFormData: any = new FormData();
  isReply: any;
  allowContractorToRespond: boolean = true;
  file: any;
  newComment: boolean;
  private unsubscribe$: Subject<void> = new Subject<void>();

  isEmojiPickerVisible: boolean = false;
  filter: AppFilter = new AppFilter();
  conversationData;
  currentUserName;
  fullScreenMode: boolean = false;
  imageSrc = {
    name: 'open',
    src: 'assets/icons/closeChat.svg',
  };
  private eventSubscription: Subscription;
  constructor(
    private modalService: SuiModalService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private userService: OrganizationService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private chatService: ChatService,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document
  ) {
    this.replyForm = fb.group({
      comment: ['', Validators.required],
      hideFromApplicant: [false],
    });
    if (window.localStorage.getItem('isAdmin')) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.organizationId = window.localStorage.getItem('organizationId');
    this.user = JSON.parse(window.localStorage.getItem('user'));
    if (this.user && this.user.image) {
      this.user.image = `${
        this.baseUrl
      }/public/image/?media=${this.user.image.replace(/\\/g, '/')}`;
    } else {
      this.user.image = 'assets/avatar/1.jpg';
    }
    this.currentUserName = `${this.user.firstName} ${this.user.lastName} ${this.user.middleName}`;
    this.user.username = this.currentUserName.trim();

    // this.messageParams = new AppFilter({ sidx: 'dateCreated', rows: 4, sord: 'asc' });
    this.messageParams = new AppFilter({
      sidx: 'position',
      rows: 1000,
      sord: 'desc',
    });
    // this.searchMessagesFilter.rules[0].data = 0;
    // this.messageParams.filters = JSON.stringify(this.searchMessagesFilter);

    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((params) => {
        this.sessionId = params.id;
        this.messages = [];
        if (this.sessionId !== 'empty') {
          this.getPage(1);
        }
        if (this.sessionId === 'empty') {
          this.chatService.fullScreenConversationEvent.next(false);
        }
      });
    setInterval(() => {
      if (this.sessionId !== 'empty') {
        this.getRefreshPage(this.messageParams.page);
      }
    }, 45000);
    this.eventSubscription = this.chatService
      .getFullScreenEvent()
      .subscribe((event) => {
        this.fullScreenMode = event;
        // this.cdr.detectChanges();
      });
  }
  type = 'CLOSE';
  goToFullScreen() {
    this.fullScreenMode = !this.fullScreenMode;
    this.type = this.fullScreenMode ? 'OPEN' : 'CLOSE';
    this.imageSrc = this.fullScreenMode
      ? {
          name: 'close',
          src: 'assets/icons/closeChat.svg',
        }
      : {
          name: 'open',
          src: 'assets/icons/openCHat.svg',
        };
    this.chatService.fullScreenConversationEvent.next(this.fullScreenMode);
    this.cdr.detectChanges();
  }
  getAcronym(inputString) {
    if (inputString) {
      const words = inputString.split(' ');
      let acronym = '';
      words.forEach((word) => {
        if (word) {
          acronym += word[0].toUpperCase();
        }
      });
      return acronym.substring(0, 2);
    } else {
      return ``;
    }
  }
  getOrganizationMessages(page) {
    this.searchFilter.rules[0].data = this.sessionId;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.filter.page = page;
    this.pending = true;
    this.chatService
      .getAllOrganizationChatSessions({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.conversationData = res['rows'][0];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getRefreshOrganizationMessages(page) {
    this.searchFilter.rules[0].data = this.sessionId;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.filter.page = page;
    this.chatService
      .getAllOrganizationChatSessions({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.conversationData = res['rows'][0];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  onReply(event) {
    this.isReply = event;
  }
  removeReply() {
    this.isReply = null;
  }
  removeFile() {
    this.fileObj = null;
    this.uploadFormData = new FormData();
  }
  showReplyForm(form) {
    this.replyBlock = form;
  }

  getPage(page) {
    this.messageParams.page = page;
    this.pending = true;
    this.chatService
      .getChatSessionMessages({
        sessionId: this.sessionId,
        params: this.messageParams,
      })
      .pipe(
        map((result) => {
          return result['rows'];
        })
      )
      .subscribe(
        (res) => {
          let conservationMessages = [];
          res.forEach((comment) => {
            comment.comment = comment.comment.replace(
              /&(?:[a-z\d]+|#\d+|#x[a-f\d]+);/gi,
              ''
            );
            conservationMessages.unshift(comment);
          });
          this.messages = this.groupMessages(conservationMessages);
          this.getOrganizationMessages(1);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getRefreshPage(page) {
    console.log(this.pending, 'pending');
    this.messageParams.page = page;
    const previouslength = this.messages.length;
    this.chatService
      .getChatSessionMessages({
        sessionId: this.sessionId,
        params: this.messageParams,
      })
      .pipe(
        map((result) => {
          return result['rows'];
        })
      )
      .subscribe(
        (res) => {
          let conservationMessages = [];
          res.forEach((comment) => {
            comment.comment = comment.comment.replace(
              /&(?:[a-z\d]+|#\d+|#x[a-f\d]+);/gi,
              ''
            );
            conservationMessages.unshift(comment);
          });
          this.messages = this.groupMessages(conservationMessages);
          if (this.messages.length > previouslength) {
            this.success = 'You have a new message on this conversation';
          }
          this.getRefreshOrganizationMessages(1);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  groupMessages(messages) {
    const groupedData = messages.reduce((groups, message) => {
      const dateKey = new Date(message.dateCreated).toDateString();
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(message);
      return groups;
    }, {});
    const sortedGroupedData = Object.entries(groupedData)
      .map(([dateKey, messages]) => ({
        date: new Date(dateKey),
        messages,
      }))
      .sort((a, b) => a.date.getTime() - b.date.getTime());
    return sortedGroupedData;
  }
  onScrollDown($event) {}

  onScrollUp($event) {
    if (!this.newComment) {
      let page = this.messageParams.page + 1;
      this.getPage(page);
    }
  }

  download(payload) {
    const url = `${this.baseUrl}/public/media/?media=${payload.filePath}`;
    window.open(url, '_blank');
  }

  send() {
    this.pending = true;

    if (this.replyForm.valid) {
      const formData = new FormData();
      if (this.fileObj) {
        formData.append('file', this.fileObj);
      }
      let data = this.replyForm.value;
      data['hideFromApplicant'] = null;
      data.comment = data.comment.replace(/(<([^>]+)>)/gi, '');
      data.comment = data.comment.replace(
        /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi,
        ' '
      );
      if (this.isReply) {
        data['parentCommentId'] = this.isReply.commentId;
      }
      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json',
      });
      formData.append('data', blob);
      const now = new Date();
      const currentHour = now.getHours();
      const currentDay = now.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
      const workingHoursStart = 8;
      const workingHoursEnd = 17;

      const isWeekend = currentDay === 0 || currentDay === 6;
      const isOutsideWorkingHours =
        currentHour < workingHoursStart || currentHour >= workingHoursEnd;

      if (isWeekend || isOutsideWorkingHours) {
        this.error =
          'Thank you for reaching out to us. Please note that we respond to inquiries only during regular business hours (Monday to Friday, 8 AM to 5 PM). We will get back to you as soon as possible during that time.';
      }
      this.chatService
        .sendMessageToSession({
          sessionId: this.sessionId,
          body: formData,
        })
        .subscribe(
          (res: any) => {
            // this.success = 'Message has been sent successfully';
            this.chatService.refreshConversationEvent.next(true);
            res['documentMetadata'] = res['documentId']
              ? JSON.parse(res['documentMetadata'])
              : '';
            this.getPage(this.messageParams.page);
            const newMessageDateKey = new Date(res.dateCreated).toDateString();
            const existingGroupIndex = this.messages.findIndex(
              (group) =>
                new Date(group.date).toDateString() === newMessageDateKey
            );
            if (existingGroupIndex !== -1) {
              this.messages[existingGroupIndex].messages.push(res);
            } else {
              this.messages.push({
                date: new Date(res.dateCreated),
                messages: [res],
              });
            }

            this.messages.sort((a, b) => a.date.getTime() - b.date.getTime());
            this.shouldScrollToBottom = true;
            this.fileObj = null;
            this.isReply = null;
            this.pending = false;
            this.replyForm.reset();
          },
          (error) => {
            this.pending = false;
            this.error = 'Error uploading file!';
          }
        );
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  @ViewChild('scrollContainer') private myScrollContainer: ElementRef;

  ngOnInit() {
    this.checkAttach();
    this.scrollToBottom();

    this.activatedRoute.queryParams.subscribe((params) => {
      this.conversation = params;
    });
  }

  ngAfterViewChecked() {
    if (this.shouldScrollToBottom) {
      this.scrollToBottom();
    }
  }
  private shouldScrollToBottom = true;
  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {}
    this.shouldScrollToBottom = false;
  }

  uploadDoc($event) {
    this.fileObj = $event[0];
    this.fileName = this.fileObj['name'];
  }

  onFileChange(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    this.selectedFile = files[0];
  }

  fileUpload() {
    const formData: FormData = new FormData();
    this.documents.forEach((doc) => {
      if (this.requireDocs.indexOf(doc.documentName)) {
        formData.append(doc.documentName, doc.file, doc.file.name);
      }
    });
    return formData;
  }

  checkAttach() {
    let ifAttach = false;
    if (this.fileObj != null) {
      ifAttach = true;
    } else {
      ifAttach = false;
    }
    return ifAttach;
  }
}
